import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'
import { Flex } from 'reflexbox'

import styles from './styles.scss'
import * as R from 'ramda'

class ConfigList extends Component {
  constructor(props) {
    super(props)

    // array of configs to show in the configuration list
    this.sourcesArr = []
    // flag to indicate if any filter is enabled
    this.filterEnabled = false
  }

  isFilterEnabled(curFilter) {
    for (const filterValue in curFilter) {
      if (!curFilter.hasOwnProperty(filterValue)) continue

      if (curFilter[filterValue]) return true
    }

    return false
  }

  /**
   *
   * Check if the config fulfills the filters
   *
   * @param {any} config
   * @returns {boolean} true if the config should be shown, false otherwise
   * @memberof ConfigList
   */
  showConfig(config) {
    const filterStatus = this.props.filterStatus

    for (const filterType in filterStatus) {
      if (!filterStatus.hasOwnProperty(filterType)) continue

      const curFilter = filterStatus[filterType]

      // first check if any filter in current filter type is enabled
      // if no filter in the current filter type is enabled, then
      // skip to next filter type
      if (!this.isFilterEnabled(curFilter)) continue

      // flag to indicate if the config fufills the current filter
      let fulfillsFilter = false
      this.filterEnabled = true
      for (const filterValue in curFilter) {
        if (!curFilter.hasOwnProperty(filterValue) || !curFilter[filterValue])
          continue

        if (String(config[filterType]) === filterValue) {
          fulfillsFilter = true
          break
        }
      }

      if (!fulfillsFilter) return false
    }

    return true
  }

  /**
   *
   * Filters out vendorName, vendorPartNumber and speedGrade from
   * sources for forming the list of configurations
   *
   * @returns {Object[]} an array of Objects consisting of vendorName, vendorPartNumber and speedGrade
   * @memberof AddPopup
   */
  buildConfigs() {
    const sources = this.props.sources
    // all sources should be displayed in configuration list
    const displaySourcesArr = []
    // all sources wrapped in <div> tag
    const wrappedSources = []
    // all sources wrapped in <div> tag and should be displayed in configuration list
    let wrappedDisplaySources = []

    sources.forEach(source => {
      const displaySource = _.pick(source, Object.keys(this.props.tableHeadContent))

      for (const configName in displaySource) {
        if (!displaySource.hasOwnProperty(configName)) continue

        const rvlClass = this.props.enableRvl && !source.rvlId ? styles.nonRvl : ''

        displaySource[configName] =
          <div class={[rvlClass, styles.configListItemWrapper].join(' ')}>
            {displaySource[configName]}
          </div>
      }

      wrappedSources.push(displaySource)

      // check source configurations against filters
      if (!this.showConfig(source)) return

      displaySourcesArr.push(source)
      wrappedDisplaySources.push(displaySource)
    })

    if (!this.filterEnabled && displaySourcesArr.length === 0) {
      // if no filter is enabled, display all configurations
      this.sourcesArr = sources
      wrappedDisplaySources = wrappedSources
    } else {
      this.sourcesArr = displaySourcesArr
    }

    return wrappedDisplaySources
  }

  selectConfigSource(value) {
    return (value) => {
      const configSource = []

      // get the config object according to index
      value.forEach(configIndex => {
        configSource.push(this.sourcesArr[configIndex])
      })

      this.props.onUpdateConfig(value)
      this.props.onUpdateConfigSource(configSource)
    }
  }

   getTableHead = (tableHeadContent) =>  (
        <TableHead>
            {R.map((key) => tableHeadContent[key], R.keys(tableHeadContent))}
        </TableHead>
    )

   getModifyTableRows = (source, tableHeadContent, selected) => {
        const mapIndexed = R.addIndex(R.map);
        return(
            mapIndexed((rowContent, idx) => (
                <TableRow key={idx} selected={R.contains(idx, selected)}>
                    {mapIndexed((key, idx) => (
                        <TableCell key={idx}>{(rowContent && rowContent[key]) ? rowContent[key] : ""}</TableCell>
                    ), R.keys(tableHeadContent))}
                </TableRow>
            ), source)
        )
    }

  render() {
    return (
      <Flex styleName='configWrapper'>
        <h4>Parts:</h4>
        <Flex styleName='popupConfigListWrapper'>
            <Table
                multiSelectable={this.props.multiSelectable}
                theme={styles}
                styleName='popupConfigList'
                selectable
                onRowSelect={this.selectConfigSource()}>
                {this.getTableHead(this.props.tableHeadContent)}
                {this.getModifyTableRows(this.buildConfigs(), this.props.tableHeadContent, this.props.configSelection)}
            </Table>
        </Flex>
      </Flex>
    )
  }
}

ConfigList.propTypes = {
  enableRvl: PropTypes.bool.isRequired,

  sources: PropTypes.object.isRequired,
  configSelection: PropTypes.object.isRequired,
  filterStatus: PropTypes.object.isRequired,
  tableHeadContent: PropTypes.object.isRequired,

  onUpdateConfig: PropTypes.func.isRequired,
  onUpdateConfigSource: PropTypes.func.isRequired,
}

export default CSSModules(ConfigList, styles)
